export default {
  recharge: {
    common: {
      btn_confirm: 'Confirm',

      server_err: 'server err!',
      user_not_found_message: 'User not found',
      check_produce_message: 'Please check product',

      re_captcha_message: 'Please prove the reCaptcha',

      end: ''
    },
    index: {
      uid: 'UID',
      uid_required_message: 'Please enter uid',
      uid_message: 'Uid only number',
      uid_placeholder: 'Enter your uid',
      uid_notice: 'Your Uid lies in the middle of the PROFILE tab in the App.',

      end: ''
    },

    payment: {
      nickName: 'NickName',
      uid: 'UID',
      package: 'Package',
      diamonds: 'Diamonds',
      payment: 'Payment',
      amount: 'Amount',

      btn_return: 'return',
      btn_buy: 'Buy Now',

      pay_user_info: 'thông tin người dùng',
      name: 'Họ Tên',
      phone: 'Điện thoại',
      email: 'Email',
      btn_user_info_buy: 'Mua ngay',

      end: ''
    },

    end: ''
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js